import * as t from '../types';

const initialState = {
    data: '',
    loading: false,
    error: ''
};

export default function confirmAppointmentReducer(state = initialState, action) {
    
    const {type, payload} = action;
    switch (type) {
        case t.POST_CONFIRM_APPOINTMENT_REQUEST:
            return {
                ...state,
                loading: true
            };
        case t.POST_CONFIRM_APPOINTMENT_SUCCESS:
            return {
                ...state,
                loading: false,
                data: payload.data
            };
        case t.POST_CONFIRM_APPOINTMENT_FAILED:
            return {
                ...state,
                error: payload,
                loading: false
            };
        default:
            return state;
    }
}
